module.exports = __webpack_public_path__ + "static/media/bowen-24.979b0839.jpg";